export const YEARS_AT: Record<string, string> = {
  "Less than 1 year": "1",
  "1 to 2 years": "2",
  "3 to 5 years": "3",
  "6 to 10 years": "4",
  "More than 10 years": "5",
};

export const getYearsAtId = (name: string): string | undefined => {
  const id = YEARS_AT[name.trim()];
  if (!id) {
    console.log(`ℹ️  No LinkedIn ID found for years at: "${name}" - using text search fallback`);
  }
  return id;
};